import React from 'react';

// Styles
import styles from './PatientButtons.module.css';

// Services
import { canAccessUbikare } from '../../../services/user';

// Language
import { useTranslation } from 'react-i18next';

// Other
import { Link } from 'react-router-dom';
type PatientButtonTypeID = "patients_charts" | "patients_data_table" | "patients_polls" | "pharmacy" | "clinical_course" | 'calendar' | 'additional_data' | ''

// PatientButtons: component that renders all the buttons of  
// the PatientPage
const PatientButtons: React.FC<{
    currentTab: PatientButtonTypeID
}> = ({ currentTab }) => {

    const { t } = useTranslation();

    const accessUbikare = canAccessUbikare();

    const links = [
        { id: 'patients_charts', link: 'patients_charts', label: t('charts') },
        { id: 'patients_data_table', link: 'patients_data_table', label: t('tables') },
        { id: 'patients_polls', link: 'patients_polls', label: t('polls') },
        { id: 'pharmacy', link: 'pharmacy', label: t('pharmacy'), disabled: window.config.DISABLED_PATIENT_BUTTONS.includes('pharmacy') },
        { id: 'reports', link: 'reports', label: t('reports'), disabled: !accessUbikare },
        { id: 'clinical_course', link: 'clinical_course', label: t('clinical_course'), disabled: !accessUbikare || window.config.DISABLED_PATIENT_BUTTONS.includes('clinical_course') },
        { id: 'calendar', link: 'calendar', label: t('calendar'), disabled: !accessUbikare },
        { id: 'additional_data', link: 'additional_data', label: t('additional_data') }
    ];

    return (
        <div className={styles.patientButtonsContainer}>
            {links.map(link => !window.config.HIDE_PATIENT_BUTTONS.includes(link.id) &&
                <Link key={link.id}
                    className={`anchorButton ${styles.buttonPatient} ${currentTab === link.id ? styles.active : ''} 
                        ${link.disabled ? 'blockedButton' : ''}`}
                    to={link.link}
                >
                    {link.label}
                </Link>
            )}
        </div>
    );
};

export default PatientButtons;